// extracted by mini-css-extract-plugin
module.exports = {"text":"Porque_text__1Wzgd","card":"Porque_card__229MT"};